import type {
  PortalNavigationResponse,
  PortalSessionResponse,
  StandaloneBootstrap,
} from "@/contracts/portal";

export type PortalMode = "demo" | "janison" | "static";

export interface RuntimeConfig {
  mode: PortalMode;
  apiBaseUrl: string;
  editModeEnabled: boolean;
  usesPortalLoginPage: boolean;
  usesMockAdapter: boolean;
  standaloneBootstrapMode: "editmode" | "bootstrap";
  bootstrap: StandaloneBootstrap | null;
}

declare global {
  interface Window {
    __PORTAL_BOOTSTRAP__?: StandaloneBootstrap;
  }
}

let cachedConfig: RuntimeConfig | null = null;

export function getRuntimeConfig(): RuntimeConfig {
  if (cachedConfig) return cachedConfig;

  const envMode = import.meta.env.VITE_PORTAL_MODE;
  const mode: PortalMode = envMode === "janison" ? "janison" : envMode === "static" ? "static" : "demo";
  const bootstrap = window.__PORTAL_BOOTSTRAP__ ?? null;

  cachedConfig = {
    mode,
    apiBaseUrl: import.meta.env.VITE_PORTAL_API_BASE_URL || (mode === "static" ? "/app-data" : "/api"),
    editModeEnabled: mode === "demo",
    usesPortalLoginPage: mode === "demo",
    usesMockAdapter: mode === "demo",
    standaloneBootstrapMode: bootstrap ? "bootstrap" : "editmode",
    bootstrap,
  };

  return cachedConfig;
}

export function sessionFromBootstrap(): PortalSessionResponse | null {
  const bootstrap = getRuntimeConfig().bootstrap;
  if (!bootstrap?.session) return null;
  return bootstrap.session;
}

export function navigationFromBootstrap(): PortalNavigationResponse | null {
  const bootstrap = getRuntimeConfig().bootstrap;
  if (!bootstrap?.navigation) return null;
  return bootstrap.navigation;
}

export function trackingEnabled(): boolean {
  return getRuntimeConfig().mode === "janison";
}

export function resetRuntimeConfigForTests(): void {
  cachedConfig = null;
}
